module.exports = __webpack_public_path__ + "img/目标7.a5515527.png";